import { Component, Vue, Watch } from 'vue-property-decorator';

import template from './add-room.vue';
import { Action } from '@/store';
import { ModalState, Company, Room } from '@/definitions';

@Component({
  mixins: [template],
})
export default class AddRoom extends Vue {
  startTimes: string[] = [];
  selectedStartTime: string = '';
  endTimes: string[] = [];
  selectedEndTime: string = '';
  name: string = '';
  showErrors: boolean = false;

  @Watch('$store.state.modal.active')
  resetComponent(active: boolean) {
    if (active) {
      this.startTimes = this.getTimesArray(24, 0, 0);
      this.endTimes = this.getTimesArray(24, 0, 1);
      this.showErrors = false;
      if (this.modal.props.roomIndex !== undefined) {
        this.selectedStartTime = this.startTimes[this.rooms[this.modal.props.roomIndex].bookingStart];
        this.selectedEndTime = this.endTimes[this.rooms[this.modal.props.roomIndex].bookingEnd - 1];
        this.name = this.rooms[this.modal.props.roomIndex].friendlyName;
      } else {
        this.selectedStartTime = this.startTimes[9];
        this.selectedEndTime = this.endTimes[16];
        this.name = '';
      }
    }
  }

  @Watch('selectedStartTime')
  startTimeChange(time: string) {
    const i = this.startTimes.indexOf(time);
    this.endTimes = this.getTimesArray(24 - i, i, 1);
    if (!this.endTimes.includes(this.selectedEndTime)) {
      this.selectedEndTime = this.endTimes[0];
    }
  }

  mounted() {
    this.resetComponent(true);
  }

  get modal(): ModalState {
    return this.$Store.state.modal;
  }

  get company(): Company {
    return this.$Store.state.company.company;
  }

  get rooms(): Room[] {
    return this.$Store.state.company.rooms;
  }

  saveRoom() {
    if (this.name && !this.modal.props.disallowed.includes(this.name)) {
      const rooms = [...this.rooms];
      if (this.modal.props.roomIndex !== undefined) {
        rooms[this.modal.props.roomIndex] = {
          ...rooms[this.modal.props.roomIndex],
          friendlyName: this.name,
          bookingStart: +this.selectedStartTime.split(':')[0],
          bookingEnd: +this.selectedEndTime.split(':')[0],
        };
      } else {
        rooms.push({
          companyId: this.company._id,
          friendlyName: this.name,
          bookingStart: +this.selectedStartTime.split(':')[0],
          bookingEnd: +this.selectedEndTime.split(':')[0],
          seats: []
        });
      }
      this.$Store.dispatch(Action.UPDATE_COMPANY, { company: this.company, rooms });
      this.closeModal();
    } else {
      this.showErrors = true;
    }
  }

  closeModal(): void {
    this.$Store.dispatch(Action.HIDE_MODAL);
  }

  visibleHour(hour: number): string {
    const h = (hour < 10) ? `0${hour}` : hour;
    return `${h}:00`;
  }

  getTimesArray(amount: number, start: number, increment: number) {
    return new Array(amount).fill('').map((bool, i) => this.visibleHour(i + start + increment));
  }
}